<template>
  <div class="reportperson">
    <div class="content">
      <SelectRadio :radioData="questions" :Finished="Finished"></SelectRadio>
      <EvidenceBlock v-show="questionId" :max="9" accept="image/*" :evidenceData="evidenceData" :Finished="evidenceFinished"></EvidenceBlock>
    </div>
    <z-button-group>
      <z-button :loading="sharedData.globalLoading" :disabled="!canSubmit" type="primary" @click="submit">提交</z-button>
    </z-button-group>
  </div>
</template>

<script>
import SelectRadio from '../components/SelectRadio'
import EvidenceBlock from '../components/EvidenceBlock'
import { Button, ButtonGroup } from '@zz-common/zz-ui'
import { newReportGetQuestion } from '@api/resourceApi'
export default {
  name: 'RoutePerson',
  components: {
    zButton: Button,
    zButtonGroup: ButtonGroup,
    SelectRadio,
    EvidenceBlock
  },
  inject: ['sharedData', 'globalSubmit'],
  data() {
    return {
      evidenceData: {
        title: '请填写举报原因',
        text: '如有其他证据证明对方的违规行为，请补充',
        placeholder: '请描述事情经过'
      },
      questionId: '', //选择的问题id
      questionDesc: '', //选择的问题
      pics: '', //凭证照片 多个用逗号分割
      content: '', //凭证描述 多个用逗号分割
      //选择问题
      questions: {}
    }
  },
  computed: {
    canSubmit() {
      if (this.sharedData.evidenceLoading) return false
      return this.questionId && this.content.length >= 5
    }
  },
  created() {
    const searchtype = this.sharedData.firstReason.id
    newReportGetQuestion({ type: searchtype }).then(res => {
      this.questions = res
    })
  },
  methods: {
    Finished(data) {
      this.questionId = data.evidence
      this.questionDesc = data.desc
    },
    submit() {
      const params = {
        questionId: this.questionId,
        questionDesc: this.questionDesc,
        pics: JSON.stringify(this.pics),
        content: this.content
      }
      this.globalSubmit(params)
    },
    evidenceFinished(data) {
      this.content = data.message
      this.pics = data.files.map(t => t.url)
    }
  }
}
</script>
<style lang="less" scoped>
@import "index.less";
</style>